export const convertBlobToBase64 = async (file: Blob | Buffer): Promise<string> => {
  // Detect environment
  if (typeof window !== 'undefined' && typeof FileReader !== 'undefined' && file instanceof Blob) {
    // Browser side
    return await new Promise((resolve, reject) => {
      const reader = new FileReader()
			reader.onloadend = () => resolve(reader.result as string)
			reader.onerror = reject
			reader.readAsDataURL(file)

      // reader.onloadend = () => {
      //   if (reader.result && typeof reader.result === 'string') resolve(reader.result.split(',')[1])
      //   else reject(new Error('Failed to read file'))
      // }
      // reader.onerror = reject
      // reader.readAsDataURL(file)
    })
  } else if (Buffer.isBuffer(file)) {
    // Node side
    return file.toString('base64')
  } else {
    throw new Error('Unsupported environment or file type')
  }
}